<span *ngIf='criterionItem' (click)='switch()'
    [class.selected]="isSelected"
    [class.globalSelected]="isGlobalSelected"
    [innerHtml]="label">
</span>
